import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import { COMMON_TIMEZONES, useTimezone } from "@/lib/timezone";
import { Select } from "@/components/ui/select";
import { cn } from "@/lib/utils";

export function TimezoneSwitcher({ className, fullWidth }: { className?: string; fullWidth?: boolean }) {
  const { t } = useTranslation();
  const { timezoneSetting, resolvedTimezone, setTimezoneSetting } = useTimezone();

  const options = COMMON_TIMEZONES.map((tz) => ({
    value: tz.value,
    label: tz.value === "CLIENT" ? `${t("timezone.local", "Local browser")} (${resolvedTimezone})` : tz.label,
  }));

  return (
    <div className={cn("flex items-center gap-1.5", fullWidth && "w-full", className)}>
      {fullWidth ? null : <Globe className="size-3.5 shrink-0 text-muted" aria-hidden="true" />}
      <Select
        value={timezoneSetting}
        onValueChange={setTimezoneSetting}
        options={options}
        aria-label={t("timezone.selectAria", "Select display timezone")}
        className={cn(
          "text-xs text-muted hover:text-ink",
          fullWidth ? "h-9 w-full" : "h-7 w-auto min-w-[110px] px-2",
        )}
      />
    </div>
  );
}
